import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { TooltipProvider } from "./components/TooltipProvider";
import { useStudio } from "./useStudio";
import { ProductionNotesPage } from "./components/ProductionNotesPage";
import "@fontsource-variable/inter";
import "@fontsource-variable/manrope";
import "./styles.css";
import "./components/workspace-header.css";
class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  { error: string | null }
> {
  state = { error: null as string | null };
  static getDerivedStateFromError(error: Error) {
    return { error: error.message };
  }
  render() {
    if (this.state.error)
      return (
        <main
          style={{
            padding: 40,
            fontFamily: "system-ui",
            maxWidth: 650,
            margin: "auto",
          }}
        >
          <h1>Cue Studio needs a reload</h1>
          <p>
            Your saved script library is still in this browser. Reload to
            recover the session.
          </p>
          <pre style={{ whiteSpace: "pre-wrap" }}>{this.state.error}</pre>
          <button data-help="Reload the app to recover this session. Your saved script library stays in this browser." onClick={() => location.reload()}>Reload Cue Studio</button>
        </main>
      );
    return this.props.children;
  }
}
function StudioRoot() {
  const studio = useStudio();
  return <App studio={studio} />;
}
ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <ErrorBoundary>{new URLSearchParams(location.search).get('view') === 'notes' ? <ProductionNotesPage /> : <StudioRoot />}</ErrorBoundary>
    <TooltipProvider />
  </>,
);
